import { useEffect, useRef } from 'react';
import { notifyError } from '../utils/notify';

// Legacy component name. Originally rendered an inline red Alert above
// the form. Per the popup-everywhere standardisation we no longer show
// inline error blocks — when an `error` (or one-off `message`) prop
// arrives, this fires a single notification.error popup via the global
// notify module and renders nothing.
//
// Existing call sites (`<ErrorAlert error={someError} />`) keep working
// without per-file edits. The `style` prop is accepted for backward
// compatibility but is no longer consulted.
export default function ErrorAlert({ error, message, fallback }) {
  const lastSignatureRef = useRef(null);
  useEffect(() => {
    if (!error && !message) return;
    // Build a stable signature for de-dup: same error reference -> same
    // signature -> popup not refired. Effect already only runs when
    // props change identity, but parents that re-create the error
    // object on every render would otherwise pop up endlessly.
    const sig = message
      ? 'm:' + message
      : 'e:' + ((error && error.response && error.response.status) || '?') +
        ':' +
        ((error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.code) ||
          (error && error.message) ||
          '?');
    if (lastSignatureRef.current === sig) return;
    lastSignatureRef.current = sig;
    if (message && !error) {
      // Plain string-only callsite (rare). Show the literal text as
      // the description, generic title.
      notifyError(null, { description: message });
    } else {
      notifyError(error, fallback || {});
    }
  }, [error, message, fallback]);
  return null;
}
